import doc                     from 'decorators/doc';
import model                   from 'decorators/model';
import { computed }            from 'mobx';
import SupplierPrivateApiModel from '../../abstracts/SupplierPrivateApiModel';

@model.cacheDuration()
@model.staticLabel('Statut')
@model.urnResource('order_part_status')
@doc.path('/order_part_statuses/{?id}')
export default class OrderPartStatusModel extends SupplierPrivateApiModel {
	public _filters: ModelFiltersExtended<{
		'reference': SupplierOrderPartStatusReference;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
	}> = {};

	@doc.string declare label: string;
	@doc.string declare reference: SupplierOrderPartStatusReference;

	public get color() {
		switch (this.reference) {
			case 'in_preparation':
				return 'lightblue';
			case 'sent_to_client':
			case 'validated':
				return 'green';
			case 'to_validate':
				return 'blue';
		}
	}

	@computed
	public get name() {
		switch (this.reference) {
			case 'sent_to_client':
				return 'Transmise au fournisseur';
			default:
				return this.label;
		}
	}
}
